export const DEFAULT_SELLING_COMPANY = 'AMX Paraguay S. A. ';
export const SESSION_IDLE_TIMEOUT = 1200; // seconds

/**
 * API CONFIG
 */
export const API_URL = '/api';
export const API_TIMEOUT = 40000; // ms
export const QUERY_STALE_TIME = 300000; // stale time for frequently used request
export const MAX_RETRY_COUNT = 3;

export type WEBCOBERTURA_CONFIG = {
  URL: string;
  TOKEN_NAME: string;
};

/**
 * WEB COBERTURA
 */
export const WEBCOBERTURA: WEBCOBERTURA_CONFIG = {
  URL: '/webCoberturaFija/Principal.aspx',
  TOKEN_NAME: 'web-authorization',
} as const;

/**
 * WEB COBERTURA DTH
 */

export const WEBCOBERTURADTH: WEBCOBERTURA_CONFIG = {
  URL: '/webCoberturaDth/Principal.aspx',
  TOKEN_NAME: 'web-authorization',
} as const;

/**
 * MESSAGES
 */
export const DEFAULT_ERROR_MESSAGE = 'Error en el sistema, intente más tarde.';
export const VALIDATION_INVALID_FORMAT = 'Formato inválido';
export const INVALID_ONLY_NUMBERS = 'Este campo admite solo números';
export const VALIDATION_INVALID_BLACKLIST = 'BlackList';
export const VALIDATION_BLACKLIST_INVALID_EMAIL =
  'Dominio inválido. Ingrese uno nuevo, por favor.';
export const VALIDATION_MAX_LENGTH_MESSAGE =
  'Excediste la cantidad máxima de caracteres permitidos.';
export const VALIDATION_CI_NUMBER_INPUT =
  'El número no debe comenzar con 0, puede tener una sola letra A o B al comienzo o al final';
export const EMPTY_VALUE_PLACEHOLDER = 'No posee';

export const UPDATE_APP_TITLE = 'Actualización disponible';
export const UPDATE_APP_MESSAGE = 'Hay una nueva versión disponible!';
export const OFFLINE_MESSAGE = 'Se ha perdido la conexión a internet';
